$(function() {

  glassesPrescription._init()

})


var glassesPrescription = {

  data: { properties: {} },
  is_prism: false,
  prism_variant_id: 47602160926958,
  subtotal: 0,

  $buyButton: null,
  productFormId: '',
  productVariants: [],

  frameLensAddonVariantId: '',
  frameLensAddonPriceCents: 0,
  frameBasePriceCents: 0,
  frameLensButtonTemplate: 'Buy Frame & Lens for {price}',
  prescriptionFlow: 'standard',

  isAddingToCart: false,

  // lens 
  currentLensCoatingCost: 0,
  currentLensAddOnCost: 0,

  _init: function() {
    glassesPrescription.data = { properties: {} }

    this._initFrameLensAddon()
    this._bindEvents()
    this._refreshFrameLensButton()
  },

  _initFrameLensAddon: function() {
    const $button = $('.glasses-prescription-buy-btn').first()

    glassesPrescription.$buyButton = $button

    if (!$button.length) {
      return
    }

    glassesPrescription.productFormId =
      String($button.attr('data-product-form-id') || '')

    glassesPrescription.frameLensAddonVariantId =
      String(
        $button.attr('data-frame-lens-addon-variant-id') || ''
      )

    glassesPrescription.frameLensAddonPriceCents =
      Number(
        $button.attr('data-frame-lens-addon-price-cents')
      ) || 0

    glassesPrescription.frameLensButtonTemplate =
      String(
        $button.attr('data-frame-lens-button-template') ||
        'Buy Frame & Lens for {price}'
      )

    glassesPrescription.prescriptionFlow =
      String(
        $button.attr('data-prescription-flow') || 'standard'
      )

    const variantsJsonId =
      String($button.attr('data-variants-json-id') || '')

    const variantsJsonElement =
      document.getElementById(variantsJsonId)

    if (!variantsJsonElement) {
      return
    }

    try {
      glassesPrescription.productVariants = JSON.parse(
        variantsJsonElement.textContent
      )
    }
    catch (error) {
      console.error(
        'Unable to read glasses product variants:',
        error
      )

      glassesPrescription.productVariants = []
    }
  },

  _getSelectedFrameVariant: function() {
    let selectedVariantId = ''

    if (glassesPrescription.productFormId) {
      selectedVariantId = String(
        $('#' + glassesPrescription.productFormId)
          .find('input[name="id"]')
          .val() || ''
      )
    }

    return glassesPrescription.productVariants.find(
      function(variant) {
        return String(variant.id) === selectedVariantId
      }
    ) || glassesPrescription.productVariants[0] || null
  },

  _formatMoney: function(cents) {
    if (
      window.helper &&
      typeof window.helper._convertMoney === 'function'
    ) {
      return window.helper._convertMoney(
        Number(cents) || 0
      )
    }

    return '$' + (
      (Number(cents) || 0) / 100
    ).toFixed(2)
  },

  _refreshFrameLensButton: function() {
    const $button = glassesPrescription.$buyButton
    const selectedVariant =
      glassesPrescription._getSelectedFrameVariant()

    if (
      !$button ||
      !$button.length ||
      !selectedVariant
    ) {
      return
    }

    const isAvailable = selectedVariant.available !== false

    $button
      .prop('hidden', !isAvailable)
      .prop('disabled', !isAvailable)

    if (!isAvailable) {
      return
    }

    glassesPrescription.frameBasePriceCents =
      Number(selectedVariant.price) || 0

    if (
      glassesPrescription.frameLensAddonVariantId
    ) {
      const combinedPriceCents =
        glassesPrescription.frameBasePriceCents +
        glassesPrescription.frameLensAddonPriceCents

      $button.text(
        glassesPrescription.frameLensButtonTemplate.replace(
          /\{price\}/g,
          glassesPrescription._formatMoney(combinedPriceCents)
        )
      )
    }
    else {
      $button.text('Buy Frame & Lens')
    }
  },

  _bindEvents: function() {

    // Open Popup 
    $('.glasses-prescription-buy-btn').on('click', function() {
      glassesPrescription._openPopup()
    })

    const $productSection =
    glassesPrescription.$buyButton.closest('section')

    $productSection
      .find('variant-radios, variant-selects')
      .on(
        'change.glassesFrameLensPrice',
        function() {
          window.setTimeout(function() {
            glassesPrescription._refreshFrameLensButton()
          }, 0)
        }
      )

    // Close Popup 
    $('.glasses-prescription-module-close-btn').on('click', function() {
      glassesPrescription._closePopup()
    })

    //Usage
    $('.glasses-prescription-module__usage-select-wrapper .glasses-prescription-module__select-option').on('click', function() {
      const btn = $(this)
      const usageType = btn.data('usage')

      if(usageType != "Non-Prescription" && usageType != "Frame Only") {
        glassesPrescription._showPrescription($(this))
      }
      else {
        glassesPrescription._addToCartNonPrescription()
      }
    })

    // Prescription
    $('.glasses-prescription-module__prescription-main-step-wrapper .glasses-prescription-module__select-option').on('click', function(){
      glassesPrescription.data.properties.prescription_type = $(this).data('prescription-type')
      if($(this).hasClass('glasses-prescription-module__select-option__send-later')) {
        glassesPrescription._showLens($(this))
      }
      else {
        glassesPrescription._prescriptionType($(this))
      }
    })

    $('.glasses-prescription-module__prescription-step-back-btn').on('click', function() {
      glassesPrescription._prescriptionBackBtn($(this))
    })

    $('#pd_checkbox').on('change', function () {
      if ($(this).is(':checked')) {
        $('.glasses-prescription-module__prescription-details-row__pd').addClass('two-pd')
      } else {
        $('.glasses-prescription-module__prescription-details-row__pd').removeClass('two-pd')
      }
    });

    $('#is_prism_checkbox').on('change', function () {
      if ($(this).is(':checked')) {
        $('.glasses-prescription-module__prescription-add-prism-block-wrapper').fadeIn()
        glassesPrescription.is_prism = true
        glassesPrescription._updateSubtotal(29)
      } else {
        $('.glasses-prescription-module__prescription-add-prism-block-wrapper').hide()
        glassesPrescription.is_prism = false
        glassesPrescription._updateSubtotal(-29)
      }
    });

    $('.glasses-prescription-module__prescription-section-btn').on('click', function() {
      glassesPrescription._showLens($(this))
    })

    // Lens 
    $('.glasses-prescription-module__lens-step-back-btn').on('click', function() {
      glassesPrescription._lensBackBtn($(this))
    })

    $('.glasses-prescription-module__lens-section-btn').on('click', function() {
      glassesPrescription._showAddon($(this))
    })


    //Lens Tier Select
    $('.lens-tier').on('click', function() {
      const $btn = $(this);
      const tier = $btn.data('tier'); // essential | zeiss | hoya | eco

      // Toggle active state on buttons
      $btn.addClass('active').siblings('.lens-tier').removeClass('active');

      // Show matching tier list, hide others
      $('.glasses-lens-tier-items-list')
        .hide()
        .filter('[data-tier-options="' + tier + '"]')
        .fadeIn();

      // Show matching tier add-ons, hide others
      $('.glasses-lens-tier-items-add-ons-list')
        .hide()
        .filter('[data-tier-add-on-option="' + tier + '"]')
        .fadeIn();
    })


    //Lens Options Dropdown
    $('.glasses-prescription-module__custom-lens-option').on('click', function() {
      if (String($(this).data('variant-available')) === 'false') {
        return
      }

      glassesPrescription._selectSubOption($(this))
      $('.glasses-prescription-module__lens-section-btn').fadeIn()

      glassesPrescription.data['lens_variant_id'] = $(this).data('variant-id')
      glassesPrescription.data['properties']['lens'] = $(this).data('lens-label')
    })

    $('.glasses-prescription-module__select-index-option .glasses-prescription-module__select-option').on('click', function() {
      glassesPrescription._selectSubOptionDropDown($(this))
    })

    $('.glasses-prescription-module__select-index-option .glasses-prescription-module__select-sub-option').on('click', function() {
      if (String($(this).data('variant-available')) === 'false') {
        return
      }

      glassesPrescription._selectSubOption($(this))
      $('.glasses-prescription-module__lens-section-btn').fadeIn()

      glassesPrescription.data['lens_variant_id'] = $(this).data('variant-id')
      glassesPrescription.data['properties']['lens'] = $(this).parents('.glasses-prescription-module__select-option-with-sub').data('index') + ' - ' + $(this).data('variant-title')
    })


    //Add On
    $('.glasses-prescription-module__addon-step-back-btn').on('click', function() {
      glassesPrescription._addonBackBtn($(this))
    })

    //Add On Options Dropdown
    $('.glasses-prescription-module__select-lens-add-on-option .glasses-prescription-module__select-option').on('click', function() {
      glassesPrescription._selectSubOptionDropDown($(this))
    })

    $('.glasses-prescription-module__select-lens-add-on-option .glasses-prescription-module__select-sub-option').on('click', function() {
      glassesPrescription._selectSubOption($(this))

      glassesPrescription.data['addon_variant_id'] = $(this).data('variant-id')
      glassesPrescription.data['properties']['lens_addon'] =  $(this).parents('.glasses-prescription-module__select-option-with-sub').data('add-on') + ' - ' + $(this).data('variant-title')

      $('.glasses-prescription-module__lens-add-on-section-btn').fadeIn()
    })

    // ADD TO CART 
    $('.glasses-prescription-module__lens-add-on-section-btn').on('click', function() {
      console.log(glassesPrescription.data)

      glassesPrescription._addToCart()
    })

  },

  _openPopup: function() {

    glassesPrescription.isAddingToCart = false
    glassesPrescription._setAddToCartLoading(false)
    
    const selectedVariant =
      glassesPrescription._getSelectedFrameVariant()

    if (!selectedVariant) {
      return
    }

    glassesPrescription.data = {
      variant_id: selectedVariant.id,
      properties: {}
    }

    glassesPrescription.is_prism = false
    glassesPrescription.subtotal = 0
    glassesPrescription.currentLensCoatingCost = 0
    glassesPrescription.currentLensAddOnCost = 0

    $('#is_prism_checkbox, #pd_checkbox').prop('checked', false)
    $('.glasses-prescription-module__prescription-details-row__pd')
      .removeClass('two-pd')
    $('.glasses-prescription-module__prescription-add-prism-block-wrapper')
      .hide()

    $('.glasses-prescription-module__select-option, ' +
      '.glasses-prescription-module__select-option-with-sub, ' +
      '.glasses-prescription-module__select-sub-option')
      .removeClass('active')
    $('.glasses-prescription-module__select-option-sub-wrapper').hide()
    $('.glasses-prescription-module__lens-section-btn').hide()

    if (glassesPrescription.prescriptionFlow !== 'custom') {
      $('.lens-tier')
        .removeClass('active')
        .filter('[data-tier="essential"]')
        .addClass('active')

      $('.glasses-lens-tier-items-list')
        .hide()
        .filter('[data-tier-options="essential"]')
        .show()

      $('.glasses-lens-tier-items-add-ons-list')
        .hide()
        .filter('[data-tier-add-on-option="essential"]')
        .show()
    }

    $('.glasses-prescription-module__usage').show()
    $('.glasses-prescription-module__prescription, ' +
      '.glasses-prescription-module__lens, ' +
      '.glasses-prescription-module__addons')
      .hide()
    $('.glasses-prescription-module__prescription-main-step-wrapper').show()
    $('.glasses-prescription-module__prescription-substep-manual-details, ' +
      '.glasses-prescription-module__prescription-substep-upload')
      .hide()

    $('.glasses-prescription-module__steps-indicator-block')
      .removeClass('current completed')
    $('[data-indicator="usage"]').addClass('current')

    glassesPrescription.frameBasePriceCents =
      Number(selectedVariant.price) || 0

    const startingPriceCents =
      glassesPrescription.frameBasePriceCents +
      glassesPrescription.frameLensAddonPriceCents

    glassesPrescription._updateSubtotal(
      startingPriceCents / 100
    )

    $('.glasses-prescription-module-wrapper').fadeIn()

    $('.glasses-prescription-module-preview-img').attr(
      'src',
      $('.product__media').find('img').attr('src')
    )

    $('.glasses-prescription-module-preview-title').html(
      $('.product__title').html()
    )

    $('html, body').addClass(
      'glasses-prescription-lock'
    )

    $('.glasses-prescription-module').scrollTop(0)
  },

  _closePopup: function() {
    $('.glasses-prescription-module-wrapper').fadeOut();

    $('html, body').removeClass('glasses-prescription-lock')
    glassesPrescription.subtotal = 0
  },

  _showPrescription: function(btn) {
    const usage = btn.data('usage')

    $('.glasses-prescription-module__usage').hide()
    $('[data-indicator="usage"]').removeClass('current')
    $('[data-indicator="usage"]').addClass('completed')
    $('[data-indicator="prescription"]').addClass('current')
    
    switch (usage) {
      case 'Non-Prescription':
        
        break;
      case 'Frame Only':

        break
      default:
        $('.glasses-prescription-module__prescription').show();
        glassesPrescription.data['properties']['usage'] = usage
        break;
    }

    glassesPrescription._scrollModuleTop()
  },

  _prescriptionType: function(btn) {
    const prescriptionType = btn.data('prescription-type')

    $('.glasses-prescription-module__prescription-main-step-wrapper').hide()
    $('.glasses-prescription-module__prescription-section-btn').html('Continue')
    $('.glasses-prescription-module__prescription-section-btn').data('action', 'continue')
    
    switch (prescriptionType) {
      case 'Upload file':
        $('.glasses-prescription-module__prescription-substep-upload').show();
        $('.glasses-prescription-module__prescription-step-back-btn').data('back-step', 1)
        break;
      case 'Send later':

        break
      default:
        $('.glasses-prescription-module__prescription-substep-manual-details').show()
        $('.glasses-prescription-module__prescription-step-back-btn').data('back-step', 1)
        break;
    }

  },

  _prescriptionBackBtn: function(btn) {

    if(btn.data('back-step') == 0) {
      $('.glasses-prescription-module__prescription').hide()
      $('.glasses-prescription-module__usage').show()
      $('[data-indicator="usage"]').addClass('current')
      $('[data-indicator="usage"]').removeClass('completed')
      $('[data-indicator="prescription"]').removeClass('current')
    }
    else {
      btn.data('back-step', 0)
      $('.glasses-prescription-module__prescription-substep-manual-details').hide()
      $('.glasses-prescription-module__prescription-substep-upload').hide()
      $('.glasses-prescription-module__prescription-main-step-wrapper').show()
    }

    glassesPrescription._scrollModuleTop()

  },

  _showLens: function(btn) {
    if(glassesPrescription.data['properties']['prescription_type'] == 'Upload file') {
      glassesPrescription.data['properties']['prescription_upload'] = $('#glassesUploadPrescription')[0].files[0]
    }

    if(glassesPrescription.data['properties']['prescription_type'] == 'Enter manually') {
      glassesPrescription.data['properties']['right_sph'] = $('[name="sphere_right"]').val()
      glassesPrescription.data['properties']['left_sph'] = $('[name="sphere_left"]').val()
      glassesPrescription.data['properties']['right_cyl'] = $('[name="cylinder_right"]').val()
      glassesPrescription.data['properties']['left_cyl'] = $('[name="cylinder_left"]').val()
      glassesPrescription.data['properties']['right_axi'] = $('[name="axis_right"]').val()
      glassesPrescription.data['properties']['left_axi'] = $('[name="axis_left"]').val()

      if($('#pd_checkbox').is(':checked')) {
        glassesPrescription.data['properties']['pd_value'] = "Left: "+$('[name="left_pd"]').val()+", Right: " + $('[name="right_pd"]').val()
      }
      else {
        glassesPrescription.data['properties']['pd_value'] = $('[name="pdist"]').val()
      }

      glassesPrescription.data['properties']['additional_info'] = $('[name="additional_info"]').val()
      glassesPrescription.data['properties']['birth_year'] = $('[name="birth_year"]').val()
      glassesPrescription.data['properties']['gender'] = $('[name="gender"]').val()
    }

    $('[data-indicator="prescription"]').removeClass('current')
    $('[data-indicator="prescription"]').addClass('completed')

    if (glassesPrescription.prescriptionFlow !== 'custom') {
      const index = this._getLensIndex()

      $('.glasses-prescription-module__lens-select-wrapper .glasses-prescription-module__select-option')
        .removeClass('active')
        .filter(`[data-index="${index}"]`)
        .addClass('active')
    }

    $('[data-indicator="lens"]').addClass('current')

    $('.glasses-prescription-module__prescription').hide()
    $('.glasses-prescription-module__lens').show()

    glassesPrescription._scrollModuleTop()
  },

  _lensBackBtn: function() {
    $('[data-indicator="prescription"]').addClass('current')
    $('[data-indicator="prescription"]').removeClass('completed')
    $('[data-indicator="lens"]').removeClass('current')

    $('.glasses-prescription-module__prescription').show()
    $('.glasses-prescription-module__lens').hide();

    glassesPrescription._scrollModuleTop()
  },

  _showAddon: function() {
    if (glassesPrescription.prescriptionFlow === 'custom') {
      glassesPrescription._addToCart()
      return
    }

    $('[data-indicator="lens"]').removeClass('current')
    $('[data-indicator="lens"]').addClass('completed')
    $('[data-indicator="addons"]').addClass('current')

    $('.glasses-prescription-module__lens').hide()
    $('.glasses-prescription-module__addons').show();

    glassesPrescription._scrollModuleTop()
  },

  _addonBackBtn: function() {
    $('[data-indicator="lens"]').addClass('current')
    $('[data-indicator="lens"]').removeClass('completed')
    $('[data-indicator="addons"]').removeClass('current')

    $('.glasses-prescription-module__lens').show()
    $('.glasses-prescription-module__addons').hide();

    glassesPrescription._scrollModuleTop()
  },

  _getLensIndex: function () {
    const rx = this._getPrescriptionSummary()

    $('.glasses-prescription-module__select-index-option').each(function () {

      const idx = String($(this).data('index')); // ensures it's a string

      $(this).show();
      $(this).removeClass('recommended')

      if (rx.sph <= 3.50 && rx.cyl <= 1.50) {
        
        //Recommended 
        if (idx.includes('1.60')) {
          $(this).addClass('recommended')
        }

        return '1.50'
      }

      if (rx.sph <= 4.50 && rx.cyl <= 3.00) {
        if (idx.includes('1.50')) {
          $(this).hide();
          $(this).next().next().addClass('recommended')
        }

        //Recommended 
        if (idx.includes('1.67')) {
          $(this).addClass('recommended')
        }

        return '1.60'
      }

      if (rx.sph <= 6.00 && rx.cyl <= 3.00) {
        if (idx.includes('1.50')) {
          $(this).hide();
        }
        if (idx.includes('1.60')) {
          $(this).hide();
          $(this).next().addClass('recommended')
        }

        //Recommended 
        if (idx.includes('1.67')) {
          $(this).addClass('recommended')
        }

        return '1.67'
      }

      if (idx.includes('1.50')) {
        $(this).hide();
      }
      if (idx.includes('1.60')) {
        $(this).hide();
      }
      if (idx.includes('1.67')) {
        $(this).hide();
      }

      //Recommended 
      if (idx.includes('1.74')) {
        $(this).addClass('recommended')
      }

      return '1.74'
      $(this).addClass('recommended')
      
    });

    
  },

  _getPrescriptionSummary: function () {
    const sphR = Math.abs(parseFloat($('[name="sphere_right"]').val()) || 0)
    const sphL = Math.abs(parseFloat($('[name="sphere_left"]').val()) || 0)
    const cylR = Math.abs(parseFloat($('[name="cylinder_right"]').val()) || 0)
    const cylL = Math.abs(parseFloat($('[name="cylinder_left"]').val()) || 0)

    return {
      sph: Math.max(sphR, sphL),
      cyl: Math.max(cylR, cylL)
    }
  },

  _selectSubOptionDropDown: function(btn) {
    if(btn.hasClass('active')) {
      btn.removeClass('active')
      btn.parent().removeClass('active')
      btn.parent().find('.glasses-prescription-module__select-option-sub-wrapper').slideUp()
    }
    else {
      $('.glasses-prescription-module__select-option, .glasses-prescription-module__select-option-with-sub').removeClass('active')
      $('.glasses-prescription-module__select-option-sub-wrapper').slideUp()
      btn.addClass('active')
      btn.parent().addClass('active')
      btn.parent().find('.glasses-prescription-module__select-option-sub-wrapper').slideDown()
    }
  },

  _selectSubOption: function(btn) {
    if(btn.hasClass('active')) {
      // btn.removeClass('active')
    }
    else {
      btn.parents('.glasses-prescription-module__select-wrapper').find('.glasses-prescription-module__select-sub-option').removeClass('active')
      btn.addClass('active')
      
      // Lens 
      if(btn.data('custom-lens') != undefined) {

        glassesPrescription._updateSubtotal(-Math.abs(glassesPrescription.currentLensCoatingCost))

        glassesPrescription.currentLensCoatingCost = parseFloat(btn.data('variant-price'))
        glassesPrescription._updateSubtotal(glassesPrescription.currentLensCoatingCost)

      }
      else if(btn.parents('.glasses-prescription-module__select-option-with-sub').data('lens') != undefined) {
        
        glassesPrescription._updateSubtotal(-Math.abs(glassesPrescription.currentLensCoatingCost))

        glassesPrescription.currentLensCoatingCost = parseFloat(btn.data('variant-price'))
        glassesPrescription._updateSubtotal(glassesPrescription.currentLensCoatingCost)

      }
      else if (btn.parents('.glasses-prescription-module__select-option-with-sub').data('lens-add-on') != undefined) {
        
        glassesPrescription._updateSubtotal(-Math.abs(glassesPrescription.currentLensAddOnCost))
        
        glassesPrescription.currentLensAddOnCost = parseFloat(btn.data('variant-price'))
        glassesPrescription._updateSubtotal(glassesPrescription.currentLensAddOnCost)
        
      }
    }
  },

  _addToCart: function() {

    if (glassesPrescription.isAddingToCart) {
      return
    }

    glassesPrescription.isAddingToCart = true
    glassesPrescription._setAddToCartLoading(true)

    const formData = new FormData();
    const uniqueId = 'id_'+ Date.now();

    formData.append('items[0][id]', glassesPrescription.data.variant_id);
    formData.append('items[0][quantity]', 1);
    formData.append('items[0][properties][properties_id]', uniqueId);
    formData.append('items[0][properties][master]', '1');
    formData.append('items[0][properties][glasses_prescription]', uniqueId);
    formData.append('items[0][properties][Usage]', glassesPrescription.data.properties.usage);
    formData.append('items[0][properties][SPH]', "Left: "+glassesPrescription.data.properties.left_sph+", Right: "+glassesPrescription.data.properties.right_sph);
    formData.append('items[0][properties][CYL]', "Left: "+glassesPrescription.data.properties.left_cyl+", Right: "+glassesPrescription.data.properties.right_cyl);
    formData.append('items[0][properties][AXI]', "Left: "+glassesPrescription.data.properties.left_axi+", Right: "+glassesPrescription.data.properties.right_axi);
    formData.append('items[0][properties][PD]', glassesPrescription.data.properties.pd_value);

    if (
      glassesPrescription.data.properties.lens
    ) {
      formData.append(
        'items[0][properties][Lens]',
        glassesPrescription.data.properties.lens
      )
    }

    if (
      glassesPrescription.prescriptionFlow !== 'custom' &&
      glassesPrescription.data.properties.lens_addon
    ) {
      formData.append(
        'items[0][properties][Lens Add-On]',
        glassesPrescription.data.properties.lens_addon
      )
    }

    if($('#glassesUploadPrescription')[0].files.length > 0) {
      formData.append('items[0][properties][prescription_upload]', glassesPrescription.data.properties.prescription_upload);
    }

    formData.append('items[0][properties][Additional Info]', glassesPrescription.data.properties.additional_info);
    formData.append('items[0][properties][Birth Year]', glassesPrescription.data.properties.birth_year);
    formData.append('items[0][properties][Gender]', glassesPrescription.data.properties.gender);

    // Lens 
    let nextItemIndex = 1

    const appendGroupedItem = function(
      variantId,
      additionalProperties
    ) {
      if (!variantId) {
        return
      }

      const itemIndex = nextItemIndex
      nextItemIndex += 1

      formData.append(
        'items[' + itemIndex + '][id]',
        variantId
      )

      formData.append(
        'items[' + itemIndex + '][quantity]',
        1
      )

      formData.append(
        'items[' + itemIndex + '][properties][properties_id]',
        uniqueId
      )

      formData.append(
        'items[' + itemIndex + '][properties][glasses_prescription]',
        uniqueId
      )

      $.each(
        additionalProperties || {},
        function(propertyName, propertyValue) {
          formData.append(
            'items[' +
              itemIndex +
              '][properties][' +
              propertyName +
              ']',
            propertyValue
          )
        }
      )
    }


    // Frame & lens base-price add-on
    appendGroupedItem(
      glassesPrescription.frameLensAddonVariantId
    )


    // Selected standard, Scenario 2, or custom prescription lens
    appendGroupedItem(
      glassesPrescription.data.lens_variant_id
    )


    // Optional lens add-on
    if (
      glassesPrescription.prescriptionFlow !== 'custom' &&
      glassesPrescription.data.addon_variant_id !== '' &&
      glassesPrescription.data.addon_variant_id !== undefined
    ) {
      appendGroupedItem(
        glassesPrescription.data.addon_variant_id
      )
    }


    // Optional prism
    if (glassesPrescription.is_prism) {
      appendGroupedItem(
        glassesPrescription.prism_variant_id,
        {
          'Vertical':
            'Left: ' +
            $('[name="prism_vertical_left"]').val() +
            ', Right: ' +
            $('[name="prism_vertical_right"]').val(),

          'Vertical Direction':
            'Left: ' +
            $('[name="prism_vertical_direction_left"]').val() +
            ', Right: ' +
            $('[name="prism_vertical_direction_right"]').val(),

          'Horizontal':
            'Left: ' +
            $('[name="prism_horizontal_left"]').val() +
            ', Right: ' +
            $('[name="prism_horizontal_right"]').val(),

          'Horizontal Direction':
            'Left: ' +
            $('[name="prism_horizontal_direction_left"]').val() +
            ', Right: ' +
            $('[name="prism_horizontal_direction_right"]').val()
        }
      )
    }

    

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData
    })
    .then(function(response) {
      return response.json().then(function(json) {
        if (!response.ok) {
          throw new Error(
            json.description ||
            json.message ||
            'Unable to add this item to the cart.'
          )
        }

        return json
      })
    })
    .then(function() {
      // Keep the button disabled while redirecting.
      window.location.href = '/cart'
    })
    .catch(function(error) {
      console.error('Unable to add glasses to cart:', error)

      glassesPrescription.isAddingToCart = false
      glassesPrescription._setAddToCartLoading(false)
    })

    
  },

  _setAddToCartLoading: function(isLoading) {
    const buttonSelector =
      glassesPrescription.prescriptionFlow === 'custom'
        ? '.glasses-prescription-module__lens-section-btn'
        : '.glasses-prescription-module__lens-add-on-section-btn'

    const $button = $(buttonSelector)

    $button
      .prop('disabled', isLoading)
      .attr('aria-busy', isLoading ? 'true' : 'false')
      .toggleClass('is-loading', isLoading)

    $button
      .find('.glasses-prescription-module__button-loader')
      .toggleClass('hidden', !isLoading)
  },

  _addToCartNonPrescription: function() {
    const formData = new FormData();
    const uniqueId = 'id_'+ Date.now();

    formData.append('items[0][id]', glassesPrescription.data.variant_id);
    formData.append('items[0][quantity]', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData
    })
    .then(response => {
      return response.json();
    })
    .then((json) => {

      console.log(json);
      
        // if(json.message == "Cart Error") {
        //   $('.product-form__error-messages p').html(json.description);
        // }

      window.location = '/cart'

    })
    .catch((error) => {
      console.error('Error:', error);
      
        // optionsSelector._addToCartBtnLoader(false)
    });
  },

  _scrollModuleTop: function() {
    $('.glasses-prescription-module').scrollTop(0)
  },

  _updateSubtotal: function(amount) {
    glassesPrescription.subtotal =
      Math.round(
        (
          glassesPrescription.subtotal +
          Number(amount || 0)
        ) * 100
      ) / 100

    $('.glasses-prescription-module-preview-footer-subtotal-price')
      .html(
        '$' +
        glassesPrescription.subtotal.toFixed(2) +
        ' AUD'
      )
  }

}
